import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getAssetFollowers = async (id: number | string) => {
  const { data: userData } = await supabase.auth.getSession()

  const { data, error } = await supabase
    .from('assets')
    .select(`
      id,
      followingCount:user_profiles!following_users_assets (count),
      isFollowedByMe:user_profiles!following_users_assets (count)
    `)
    .eq('isFollowedByMe.id', userData?.session?.user?.id || '')
    .eq('id', id)
    .eq('active', true)
    .single()

  if (error) {
    throw new Error(error.message)
  }

  // @ts-ignore
  data.followingCount = data.followingCount?.[0]?.count
  // @ts-ignore
  data.isFollowedByMe = Boolean(data.isFollowedByMe?.[0]?.count)

  return data
}

export default function useAssetFollowers(id: number | string) {
  return useQuery({
    queryKey: ['assetFollowers', id],
    queryFn: () => getAssetFollowers(id),
    staleTime: 60000,
    enabled: !!id,
  })
}
